module.exports = __webpack_public_path__ + "static/media/mail.bebe8019.svg";